module.exports = __webpack_public_path__ + "static/media/tex-trends-top10-fw-2425.83c3d907.png";